<template>
    <el-row>
      <el-row>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>营销</el-breadcrumb-item>
        <el-breadcrumb-item>限时折扣</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row class="'toolbar" style="text-align: right;">
      <el-form :inline="true" size="small" :model="sData" class="form-inline">
        <el-form-item label="促销搜索">
          <el-input size="42" v-model="sData.q" placeholder="请输入限时折扣名称..."></el-input>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>促销搜索</el-button>
            <el-button type="primary" @click="addBoxShow = true"><i class="el-icon-circle-check" style="font-weight: bolder; margin-right: 6px;"></i>新增促销</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </el-row>
      <div id="bodycontainer">
        <el-table v-loading="pageloading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" :data="cpList" stripe>
          <el-table-column width="32" type="expand">
           <template slot-scope="scope">
             <ul style="list-style: none; column-count: 5; column-gap: normal; box-sizing: padding-box;">
               <li v-for="(att, attkey) in JSON.parse(scope.row.ext)" :key="att"><b>{{ attkey }}: </b>{{ att }}</li>
             </ul>
           </template>
         </el-table-column>
          <el-table-column prop="ID" label="ID"></el-table-column>
          <el-table-column prop="Type.showName" label="促销类型"></el-table-column>
          <el-table-column prop="title" label="促销标题" width="320"></el-table-column>
          <el-table-column prop="keywords" label="促销关键词"  width="340"></el-table-column>
          <el-table-column label="促销时间" width="340">
            <template  slot-scope="scope">
              <el-tag type="danger" style="border-radius: 22px;">{{ imeformer(scope.row.startAt) }} - {{ imeformer(scope.row.endAt) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="优惠模式" width="110">
            <template  slot-scope="scope">
              <el-tag v-if="scope.row.discountType === 2" type="warning">百分比</el-tag>
              <el-tag v-else type="warning">固定减免</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="discountValue" label="优惠价值"></el-table-column>
           <el-table-column label="创建时间" width="220">
            <template  slot-scope="scope">
              {{ imeformer(scope.row.createAt) }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="250">
            <template slot-scope="scop">
              <el-button-group>
                <el-button type="text">编辑</el-button>
                <el-button type="text" @click="showgdeditor(scop.row.ID)">产品</el-button>
              </el-button-group>
            </template>
          </el-table-column>
          </el-table>
      </div>
      <div id="pagination">
          <el-pagination
            @current-change="loadDiscount"
            :current-page="cpPage.page"
            :page-sizes="[15]"
            :page-size="15"
            layout="total, sizes, prev, pager, next, jumper"
            :total="cpPage.total">
          </el-pagination>
        </div>
      <el-dialog :visible.sync="addBoxShow">
        <el-form :model="newsale" ref="newForm">
          <el-form-item prop="title" label="促销标题" required>
            <el-input v-model="newsale.title" placeholder="请输入促销标题(与网站语言一致)"></el-input>
          </el-form-item>
          <el-form-item prop="discountType" label="优惠模式" required>
            <el-radio-group v-model="newsale.discountType">
              <el-radio label="2">百分比</el-radio>
              <el-radio label="1">固定减免</el-radio>
            </el-radio-group>
          </el-form-item>
           <el-form-item prop="discountValue" label="优惠价值" required>
            <el-input v-model="newsale.discountValue" placeholder="请输入促销价值,最多支持两位小数">
            </el-input>
          </el-form-item>
          <el-form-item label="开始时间" prop="startAt" :rules="{required: true, message: '广告开始时间不能为空', trigger: 'blur'}">
              <el-date-picker v-model="newsale.startAt" type="datetime" placeholder="选择开始日期时间" :change="getStart" align="right" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="endAt" :rules="{required: true, message: '广告结束时间不能为空', trigger: 'blur'}">
              <el-date-picker v-model="newsale.endAt" type="datetime" placeholder="选择结束日期时间" :change="getEnd" align="right" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          <el-form-item label="促销类型" required>
            <el-select v-model="newsale.Type_id" placeholder="请选择活动类型" @change="makeext">
              <el-option v-for="(item, gskey) in saletype" :key="gskey" :label="item.showName" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="keywords" label="促销关键词" required>
            <el-input v-model="newsale.keywords" placeholder="请输入促销关键词"></el-input>
          </el-form-item>
           <el-form-item v-for="ext in exts.ext" :key="ext.ID" :label="ext.showName" :prop="'ext__' + ext.key" required>
            <el-input v-model="newsale['ext__' + ext.key]" :placeholder="ext.placeorder" :type="ext.type"></el-input>
          </el-form-item>
           <el-form-item prop="desc" label="促销说明" required>
            <el-input type="textarea" :rows="5" v-model="newsale.desc" placeholder="请输入促销说明"></el-input>
          </el-form-item>
          <el-form-item style="text-align: right;">
            <el-button type="primary" @click="handleNewDiscount('newForm')"><i class="el-icon el-icon-check"></i>新促销申请</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog :visible.sync="showaddspubox">
        <el-form :model="newspu" ref="newSpuForm">
          <el-form-item prop="items" label="产品SPU">
            <el-input type="textarea" :rows="10" v-model="newspu.items" placeholder="请输入促销产品spu,一行一个,格式为'spu|促销个数'"></el-input>
          </el-form-item>
          <el-form-item style="text-align: right;">
            <el-button type="primary" @click="handledealitem('newSpuForm')"><i class="el-icon el-icon-check"></i>促销产品提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-row>
</template>
<script>
export default {
  name: 'Sale',
  data () {
    return {
      sData: {},
      pageinfo: {page: 0, total: 0, num: 15, data: []},
      load: '',
      pageloading: false,
      cpPage: {page: 1, 'total': 0},
      cpList: [],
      addBoxShow: false,
      addData: {startAt: '', endAt: ''},
      cpTypeRoute: {},
      saletype: {},
      newsale: {discountType: '2'},
      exts: {},
      showaddspubox: false,
      newspu: {}
    }
  },
  mounted () {
    this.loadDiscount(1)
    this.GetTypes()
  },
  methods: {
    showgdeditor: function (sid) {
      this.newspu.sid = sid
      this.showaddspubox = true
    },
    getStart: function (data) {
      var that = this
      this.$set(that.newsale, 'startAt', data)
    },
    getEnd: function (data) {
      var that = this
      this.$set(that.newsale, 'endAt', data)
    },
    imeformer: function (v) {
      var d = new Date(v)
      return (d.toLocaleString())
    },
    makeext: function (key) {
      this.exts = this.saletype[key]
    },
    hasloaded: function () {
      this.load.close()
      this.load = ''
    },
    fullLoad () {
      this.load = this.$loading({
        lock: true,
        text: '请求处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    loadDiscount: function (page) {
      var that = this
      this.$set(that.cpPage, 'page', page)
      var para = {}
      para.method = 'shop.dealpage'
      para.page = page
      para.num = 15
      that.fullLoad()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        that.$set(that.cpPage, 'total', ret.body.data.count)
        that.cpList = ret.body.data.data
      })
    },
    handleNewDiscount: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.newsale
          para.method = 'shop.AddDiscount'
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.data.code === 200) {
              that.$message.success('新促销活动申请在功!')
              that.addBoxShow = false
              that.loadDiscount(1)
            } else {
              that.$alert('新促销活动设置失败，请稍后重试!')
            }
          })
        }
      })
    },
    handledealitem: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.newspu
          para.method = 'shop.gendiscount'
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.data.code === 200) {
              that.$message.success('促销产品申请在功!')
              that.showaddspubox = false
              that.loadDiscount(that.cpPage.padding)
            } else if (ret.body.data.code === 200) {
              that.$alert('产品SPU在系统内不存在,请检查后再提交!')
            } else {
              that.$alert('促销产品设置失败，请稍后重试!')
            }
          })
        }
      })
    },
    GetTypes: function () {
      var para = {}
      para.method = 'shop.GetDiscountType'
      var that = this
      that.$http.post(that.$apiurl, para).then(function (ret) {
        var dd = {}
        var tx = ret.body.data
        tx.forEach(function (key, index) {
          dd[key.ID] = key
        })
        that.saletype = dd
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/market/Sale.vue